import type { AdminOrgDto } from '@carcheck/shared';

/**
 * The owner code's state as the card shows it (AUT-403). The plaintext is
 * never stored, so this is all the server can say:
 *   - `pending` — an issued code nobody has claimed (may coexist with an
 *     owner: a re-issue for handing the company to someone else);
 *   - `used`    — no pending code and an owner exists (they claimed one);
 *   - `none`    — neither: never issued, or the owner was removed.
 */
export type OwnerCodeState = 'pending' | 'used' | 'none';

export const ownerCodeState = (org: AdminOrgDto): OwnerCodeState => {
  if (org.pendingOwnerCode) return 'pending';
  return org.owner ? 'used' : 'none';
};
